module.exports = __webpack_public_path__ + "img/logoHDV2.ea45c59b.png";